import validate from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import remove_45trailing_45slash_45global from "/usr/src/app/client/middleware/removeTrailingSlash.global.ts";
import route_45global from "/usr/src/app/client/middleware/route.global.js";
import manifest_45route_45rule from "/usr/src/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  remove_45trailing_45slash_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}